import React from 'react'

const Rewards = () => {
  return <h1>Rewards</h1>
}

export default Rewards
